export default "__VITE_ASSET__KrvK6w8___"